// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-date-picker-month {
  display: flex;
  justify-content: center;
  padding: 0 12px 8px;
  --v-date-picker-month-day-diff: 4px;
}

:where(.vuetify-styles) .v-date-picker-month__weeks {
  display: flex;
  flex-direction: column;
  column-gap: 4px;
  font-size: 0.875rem;
}

:where(.vuetify-styles) .v-date-picker-month__weekday {
  font-size: 0.875rem;
}

:where(.vuetify-styles) .v-date-picker-month__days {
  display: grid;
  grid-template-columns: repeat(var(--v-date-picker-days-in-week), min-content);
  column-gap: 4px;
  justify-content: space-around;
  width: 100%;
}

:where(.vuetify-styles) .v-date-picker-month__day {
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  height: 40px;
  width: 40px;
}
:where(.vuetify-styles) .v-date-picker-month__day--selected .v-btn {
  background-color: rgb(var(--v-theme-surface-variant));
  color: rgb(var(--v-theme-on-surface-variant));
}
:where(.vuetify-styles) .v-date-picker-month__day .v-btn.v-date-picker-month__day-btn {
  --v-btn-height: 24px;
  --v-btn-size: 0.875rem;
}
:where(.vuetify-styles) .v-date-picker-month__day--week {
  font-size: var(--v-btn-size);
}

:where(.vuetify-styles) .v-date-picker-month__day--adjacent {
  opacity: 0.5;
}

:where(.vuetify-styles) .v-date-picker-month__day--hide-adjacent {
  opacity: 0;
}

:where(.vuetify-styles) .v-date-picker-month__events {
  height: 8px;
  left: 0;
  text-indent: 0;
  position: absolute;
  text-align: center;
  white-space: pre;
  width: 100%;
}
:where(.vuetify-styles) .v-date-picker-month__events > div {
  height: 8px;
  margin: 0 1px;
  width: 8px;
  margin-bottom: -1px;
}
:where(.vuetify-styles) .v-date-picker-month__events .v-badge--dot .v-badge__badge {
  border-radius: 4px;
  height: 8px;
  width: 8px;
}

:where(.vuetify-styles) .v-date-picker-month__day .v-date-picker-month__events {
  bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VDatePicker/VDatePickerMonth.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6EAA6E;EAC7E,eAAe;EACf,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,OAAO;EACP,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb","sourcesContent":[".v-date-picker-month {\n  display: flex;\n  justify-content: center;\n  padding: 0 12px 8px;\n  --v-date-picker-month-day-diff: 4px;\n}\n\n.v-date-picker-month__weeks {\n  display: flex;\n  flex-direction: column;\n  column-gap: 4px;\n  font-size: 0.875rem;\n}\n\n.v-date-picker-month__weekday {\n  font-size: 0.875rem;\n}\n\n.v-date-picker-month__days {\n  display: grid;\n  grid-template-columns: repeat(var(--v-date-picker-days-in-week), min-content);\n  column-gap: 4px;\n  justify-content: space-around;\n  width: 100%;\n}\n\n.v-date-picker-month__day {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  height: 40px;\n  width: 40px;\n}\n.v-date-picker-month__day--selected .v-btn {\n  background-color: rgb(var(--v-theme-surface-variant));\n  color: rgb(var(--v-theme-on-surface-variant));\n}\n.v-date-picker-month__day .v-btn.v-date-picker-month__day-btn {\n  --v-btn-height: 24px;\n  --v-btn-size: 0.875rem;\n}\n.v-date-picker-month__day--week {\n  font-size: var(--v-btn-size);\n}\n\n.v-date-picker-month__day--adjacent {\n  opacity: 0.5;\n}\n\n.v-date-picker-month__day--hide-adjacent {\n  opacity: 0;\n}\n\n.v-date-picker-month__events {\n  height: 8px;\n  left: 0;\n  text-indent: 0;\n  position: absolute;\n  text-align: center;\n  white-space: pre;\n  width: 100%;\n}\n.v-date-picker-month__events > div {\n  height: 8px;\n  margin: 0 1px;\n  width: 8px;\n  margin-bottom: -1px;\n}\n.v-date-picker-month__events .v-badge--dot .v-badge__badge {\n  border-radius: 4px;\n  height: 8px;\n  width: 8px;\n}\n\n.v-date-picker-month__day .v-date-picker-month__events {\n  bottom: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
